import { IDeleteGestaoRecebimentoEpiUseCase } from "../../../presentation/useCases/delete/delete_gestao_recebimento_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

/**
 * DeleteGestaoRecebimentoEpiUseCase
 */

export class DeleteGestaoRecebimentoEpiUseCase implements IDeleteGestaoRecebimentoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async deleteGestaoRecebimentoEpi(
    idGestaoRecebimentoEpi: number,
  ): Promise<void> {
    await this.repository.deleteGestaoRecebimentoEpi(idGestaoRecebimentoEpi);
  }
}
